export type TermMeaningFields = {
  meaningEnglish?: string | null;
  meaningHindi?: string | null;
  meaningGujarati?: string | null;
};

function hasMeaning(value: string | null | undefined): boolean {
  return (value ?? "").trim().length > 0;
}

/** Count of non-empty meaning fields (English, Hindi, Gujarati). */
export function countTermLanguageMeanings(fields: TermMeaningFields): number {
  return [
    hasMeaning(fields.meaningEnglish),
    hasMeaning(fields.meaningHindi),
    hasMeaning(fields.meaningGujarati),
  ].filter(Boolean).length;
}
